import React, { useState, useEffect, useRef, useCallback } from 'react'
import {
  Chart,
  Geom,
  Axis,
  Tooltip,
  Legend} from 'bizcharts'
const SupplierSalesTrend = (props) => {
  const cols = {
    date: {
      range: [0, 1]
    },
    value: {
      min: 0
    }
  }

  const handleJump = (e) => {
    let url = ''
    if (e.data.category && e.data.brand_id) {
      url = `${window.location.origin}${'/main/salesreport/salesstatisticsreport/salesstatisticsreport?jumpdata='}${e.data.date}${'&&category='}${e.data.category}${'&&brand_id='}${e.data.brand_id}`
    } else {
      if (e.data.category) {
        url = `${window.location.origin}${'/main/salesreport/salesstatisticsreport/salesstatisticsreport?jumpdata='}${e.data.date}${'&&category='}${e.data.category}`
      } else if (e.data.brand_id) {
        url = `${window.location.origin}${'/main/salesreport/salesstatisticsreport/salesstatisticsreport?jumpdata='}${e.data.date}${'&&brand_id='}${e.data.brand_id}`
      } else {
        url = window.location.origin + '/main/salesreport/salesstatisticsreport/salesstatisticsreport?jumpdata=' + e.data.date
      }
    } 
    return url
  }

  return (
    <Chart height={400} data={props.supplierData} scale={cols} autoFit>
      <Legend marker={{
        symbol: 'line',
        style: {
          fill: ''
        }
      }}
      />
      <Axis name="date" />
      <Axis
        name="value"
        label={{
          formatter: val => `${val}`
        }}
      />

      <Tooltip
        shared={true}
        lock
        enterable
        showCrosshairs
        style={{
          color: 'red'
        }}
      >
        {
          (title, items) => {
            return <div style={{ padding: 10 }}>
              {title}
              <div>
                {
                  items.map(it => {
                    // console.log(it) // 这里可以获取颜色等信息
                    return <div style={{margin: '8px 8px'}}><span><span style={{ display: 'inline-block', width: '10px', height: '10px', borderRadius: '50%', background: it.color, marginRight: '8px' }}></span><span >{it.data.type + '：'}</span></span><a target="_blank" href={handleJump(it)}>{it.data.value}</a></div>
                  })
                }
              </div>
            </div>
          }
        }
      </Tooltip>

      <Geom
        type="line"
        position="date*value"
        size={2}
        color={'type'}
      />
      <Geom
        type="point"
        position="date*value*"
        size={0}
        shape={'circle'}
        color={'type'}
        style={{
          stroke: '#fff',
          lineWidth: 1
        }}
      />
    </Chart>
  )
}
export default SupplierSalesTrend



// WEBPACK FOOTER //
// ./src/pages/salesreport/salesoverview/supplierchart.js